import React, { useState, useEffect, Fragment } from "react";
import { Card, Modal } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { toast } from "react-toastify";
import { reasoncreate, reasondelete, reasondetail, resaonlist } from "../../../services/master";
import Swal from "sweetalert2";

const ReasonList = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const [Catid, setID] = useState(0);
  const [name, setName] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    funlist();
  }, []);

  function funlist() {
    setFilterProduct([]);
    resaonlist().then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data);
      }
    });
  }
  const columnDefs = [
    {
      headerName: "Reason",
      width: 670,
      field: "name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
        headerName: "Status",
        width: 100,
        field: "is_delete",
        sortable: true,
        resizable: true,
        filter: false,
        floatingFilter: false,
        cellStyle: { textAlign: "left" },
        cellRenderer: function (params) {
            return (
              <div className="text-center">
                <label className="custom-switch mb-0">
                  <input
                    type="checkbox"
                    name="custom-switch-checkbox"
                    className="custom-switch-input"
                    checked={params.value === 1 ? true : false}
                    onChange={() => handleSwitch(params)}
                  />
    
                  <span className="custom-switch-indicator"></span>
                </label>
              </div>
            );
          },
      },

    {
      headerName: "Actions",
      width: 180,
      field: "id",
      resizable: true,
      filter: false,
      // headerClass: "ag-center-aligned-header",
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => viewshow(params.value)}
              className="btn-sm btn-info"
            >
              <i className="fa fa-edit"></i>
            </a>
          </div>
        );
      },
    },
  ];

  function handleSwitch(list) {
    if (list.value === 1) {
      Swal.fire({
        text: "Are you sure want to Inactive?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Inactive",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          reasondelete(list.data.id,0).then((response) => {
            if (response.status === true) {
              funlist();
            }
          });
        }
      });
    } else {
      Swal.fire({
        text: "Are you sure want to Active?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Active",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
            reasondelete(list.data.id,1).then((response) => {
                if (response.status === true) {
                  funlist();
                }
              });
        }
      });
    }
  }

  const [show, setShow] = useState(false);
  function handleshow() {
    setID(0);
    setName("");

    setErrorMessage("");
    setShow(true);
  }

  function handleclose() {
    setID(0);

    setErrorMessage("");
    setShow(false);
  }

  function viewshow(vid) {
    setID(vid);
    setName("");
    setShow(true);

    setErrorMessage("");
    reasondetail(vid).then((response) => {
      if (response.status === true) {
        setName(response.data.name);
      }
    });
  }

  function Submitage() {
    setErrorMessage("");

    if (name !== "") {
      

        const tempData = new FormData();
        tempData.append("name", name);
        if (Catid != 0) {
          tempData.append("id", Catid);
        }
        reasoncreate(tempData).then((response) => {
          if (response.status === true) {
            handleclose();
            funlist();
            toast.success(response.message);
          } else {
           
            setErrorMessage(response.message);
          }
        });
    } else {
      setErrorMessage("Please Enter Reason");
    }
  }

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Reason List</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Settings</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Reason
            </li>
          </ol>
        </div>
      </div>
      <Row className="row-sm mx-0 mt-3">
        <Col xxl={12} lg={12} md={12}>
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <div className="res-right">
                  <a
                    onClick={handleshow}
                    variant="success"
                    type="button"
                    className="btn my-1 me-2 btn-success tx-teko"
                  >
                    {" "}
                    Add
                  </a>
                </div>
                <div className="ag-theme-alpine ag-style">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>

              <Modal show={show}>
                <Modal.Header>
                  {Catid === 0 ? <h4>Add Reason</h4> : <h4>Reason Detail</h4>}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Reason <span className="text-danger"> *</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Enter Your Reason"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </Col>

                    {errorMessage !== "" && (
                      <span className="text-danger">{errorMessage}</span>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {Catid === 0 ? (
                    <a
                      onClick={Submitage}
                      className="btn btn-next btn-success"
                      style={{ float: "right" }}
                    >
                      Submit
                    </a>
                  ) : (
                    <a
                      onClick={Submitage}
                      className="btn btn-next btn-success"
                      style={{ float: "right" }}
                    >
                      Update
                    </a>
                  )}

                  <a
                    className="btn btn-next btn-secondary"
                    style={{ float: "right" }}
                    onClick={handleclose}
                  >
                    Close
                  </a>
                </Modal.Footer>
              </Modal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ReasonList;
